import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }

  loadData(id: number): any {
    return this.http.get(`${environment.apiUrl}documents/load?id=${id}`, { responseType: 'blob' });
  }

  loadTemplateData(name: string): any {
    return this.http.get(`${environment.apiUrl}documents/load-application-template?fileName=${name}`, { responseType: 'blob' });
  }
}
